export default __webpack_public_path__ + "static/media/Burger.341b2c27.jpeg";